export default __webpack_public_path__ + "../img/8157514c6bcc1f8602688431090b792b.png";